import React from 'react';

type TMapSignature = {
  [key: string]: boolean;
};

export const useScreenMap = <TMap extends TMapSignature>(
  initialState: TMap
) => {
  const [screenMap, setScreenMap] = React.useState<TMap>(initialState);

  const enableScreen = React.useCallback((screen: keyof TMap) => {
    setScreenMap((prevValue) => ({
      ...prevValue,
      [screen]: true,
    }));
  }, []);

  const disableScreen = React.useCallback((screen: keyof TMap) => {
    setScreenMap((prevValue) => ({
      ...prevValue,
      [screen]: false,
    }));
  }, []);

  return { screenMap, enableScreen, disableScreen };
};
